import React from 'react';
import { SparklesIcon, ArrowRightIcon } from 'lucide-react';
import { trackLead } from './MetaPixel';
export function HeroSection() {
  const handleCTA = () => {
    trackLead();
    const baseUrl = 'https://closerdigital.net/F/NLeon2';
    const utmParams = '?utm_source=facebook&utm_medium=cpc&utm_campaign={{campaign.name}}&utm_adset={{adset.name}}&utm_ad={{ad.name}}&utm_content={{ad.id}}&ref=alexa';
    window.location.href = baseUrl + utmParams;
  };
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-[#0D0D0D] via-[#1C1C1C] to-[#0D0D0D] text-white overflow-hidden flex items-center" data-id="element-120">
      {/* Subtle gold glow effect */}
      <div className="absolute top-0 right-0 w-64 md:w-96 h-64 md:h-96 bg-[#D4AF37] opacity-5 blur-3xl rounded-full" data-id="element-121"></div>
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20" data-id="element-122">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-123">
          {/* Left: Copy - Shows FIRST on mobile, centered on mobile */}
          <div className="space-y-4 md:space-y-8 animate-fade-in order-1 text-center md:text-left" data-id="element-124">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full" data-id="element-125">
              <SparklesIcon className="w-4 h-4 text-[#D4AF37]" data-id="element-126" />
              <span className="text-xs md:text-sm text-[#D4AF37] font-medium" data-id="element-127">
                Certificación Elite
              </span>
            </div>
            <h1 className="font-['Playfair_Display'] text-3xl md:text-5xl lg:text-7xl font-bold leading-tight" data-id="element-128">
              Conviértete en{' '}
              <span className="text-[#FF4F75]" data-id="element-129">Closer Digital Certificado</span>
            </h1>
            <p className="text-base md:text-xl lg:text-2xl text-gray-300 leading-relaxed font-['Inter']" data-id="element-130">
              Domina el sistema probado de ventas high-ticket junto al equipo
              élite de Alexa Narvaez. Transforma tu vida y alcanza la libertad
              que siempre soñaste.
            </p>
            <div className="pt-2 md:pt-4 flex justify-center md:justify-start" data-id="element-131">
              <button onClick={handleCTA} className="group inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 bg-gradient-to-r from-[#FF4F75] to-[#D4AF37] rounded-full font-['Montserrat'] font-semibold text-sm md:text-base text-white transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)]" data-id="element-132">
                <span data-id="element-133">Descubre Cómo Funciona</span>
                <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" data-id="element-134" />
              </button>
            </div>
            <p className="text-sm md:text-base text-gray-400 italic font-['Inter'] pt-2 md:pt-4" data-id="element-135">
              "No es vender, es dominar tu libertad."
            </p>
          </div>
          {/* Right: Image - Shows SECOND on mobile, centered */}
          <div className="relative order-2 flex justify-center" data-id="element-136">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#FF4F75]/20 to-[#D4AF37]/20 blur-3xl" data-id="element-137"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/acKLPU5gmFaqiCtcf671cb/WhatsApp_Image_2025-11-02_at_2.14.03_PM_%281%29.jpg" alt="Alexa Narvaez - Mentora Digital" className="relative rounded-2xl md:rounded-3xl shadow-2xl w-full max-w-md md:max-w-none h-auto object-cover object-center border border-[#D4AF37]/20" data-id="element-138" />
          </div>
        </div>
      </div>
    </section>;
}